module.exports = __webpack_public_path__ + "static/media/image_288.a9faa589.png";